// extracted by mini-css-extract-plugin
export default {"about-section":"About_about-section__OKFQR","headline":"About_headline__jyyDe","description":"About_description__+dvZe","content-wrapper":"About_content-wrapper__OCuLm"};